import {
  SET_GOALS,
  SET_LOCATION_CONFIG,
  SET_AMOUNT,
  SET_ORGANIZATIONS,
  SET_RULES,
  SET_SELECTED_GOAL,
  SET_PAYMENT_INFO,
  SET_SELECTED_ORGANIZATION,
  SET_VOUCHERS,
  SET_LOCATION_DESIGN_CONFIG,
} from './constants'
import { AppContextAction, AppContextState } from './types'

const reducer = (
  state: AppContextState,
  action: AppContextAction
): AppContextState => {
  switch (action.type) {
    case SET_LOCATION_DESIGN_CONFIG:
      return {
        ...state,
        locationDesignConfig: action.locationDesignConfig,
      }
    case SET_LOCATION_CONFIG:
      return {
        ...state,
        locationConfig: action.locationConfig,
      }
    case SET_ORGANIZATIONS:
      return {
        ...state,
        organizations: action.organizations,
      }
    case SET_SELECTED_ORGANIZATION:
      return {
        ...state,
        selectedOrganization: action.selectedOrganization,
      }
    case SET_GOALS:
      return {
        ...state,
        goals: action.goals,
      }
    case SET_SELECTED_GOAL:
      return {
        ...state,
        selectedGoal: action.selectedGoal,
      }
    case SET_AMOUNT:
      return {
        ...state,
        amount: action.amount,
      }
    case SET_RULES:
      return {
        ...state,
        rules: action.rules,
      }
    case SET_VOUCHERS:
      return {
        ...state,
        vouchers: action.vouchers,
      }
    case SET_PAYMENT_INFO:
      return {
        ...state,
        paymentInfo: action.paymentInfo,
      }
    default:
      return state
  }
}

export default reducer
